import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, description?: string) => void;
  initialName: string;
  initialDescription?: string;
  isLoading?: boolean;
  entityType: "project" | "folder";
}

export const EditModal: React.FC<EditModalProps> = ({
  isOpen,
  onClose,
  onSave,
  initialName,
  initialDescription = "",
  isLoading = false,
  entityType,
}) => {
  const { t } = useTranslation("common");
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isOpen) {
      setName(initialName);
    }
  }, [isOpen, initialName]);

  const handleSave = () => {
    if (name.trim()) {
      // Projects don't have description, only folders might need it
      onSave(name.trim(), undefined);
    }
  };

  const handleClose = () => {
    setName(initialName);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent bg={"white"}>
        <ModalHeader>
          {entityType === "project"
            ? t("projects.editProject")
            : t("projects.editFolder")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4}>
            <FormLabel>
              {entityType === "project"
                ? t("projects.projectName")
                : t("projects.folderName")}
            </FormLabel>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={
                entityType === "project"
                  ? t("projects.enterProjectName")
                  : t("projects.enterFolderName")
              }
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" variant="ghost" mr={3} onClick={handleClose}>
            {t("chat.cancelBtn")}
          </Button>
          <Button
            size="sm"
            bg="#0E0E0E"
            color="white"
            onClick={handleSave}
            isLoading={isLoading}
            isDisabled={!name.trim()}
            _hover={{ bg: "#2D2D2D" }}
          >
            {t("projects.save")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
